module.exports = __webpack_public_path__ + "img/8.102be946.jpg";